module.exports = __webpack_public_path__ + "img/data-store.7ca4c899.svg";